import React from 'react';

import { ContainerMaintenance, TextTitle } from './style';

import splash from '../../assets/images/notFoundIcons/splash.png';

export default function PathNotFound(): JSX.Element {
  return (
    <ContainerMaintenance backImage={splash}>
      <TextTitle>Link expirado ou não existe!</TextTitle>
    </ContainerMaintenance>
  );
}
